import type { BrandId } from "@msb/reader-bridge";

/** Configuration de déploiement (variables Vite, fixées au build). */
export const config = {
  brand: (import.meta.env.VITE_BRAND ?? "mysmartbook") as BrandId,
  /** Boutique Shopware : connexion (/app/auth/login) et store-api. */
  shopUrl: (import.meta.env.VITE_SHOP_URL ?? "https://mysmartbook.fr").replace(/\/+$/, ""),
  /** Clé publique du canal de vente (sw-access-key), la même que celle de l'app. */
  shopAccessKey: import.meta.env.VITE_SHOP_ACCESS_KEY ?? "",
  /** Serveur de publications ; vide = même origine que le reader. */
  readerApiUrl: (import.meta.env.VITE_READER_API_URL ?? "").replace(/\/+$/, ""),
  aiApiUrl: import.meta.env.VITE_AI_API_URL ?? "https://ai.mysmartbook.fr",
};

export const appName = config.brand === "chatnovel" ? "ChatNovel" : "MySmartBook";
